import './App.css';
import AllUsers from './Components/AllUsers';

function App() {
  return (
    <div className="App">
      <AllUsers />
    </div>
  );
}

export default App;
